import { Action } from 'redux';

export const CREATE_USUARIO_REQUEST = 'CREATE_USUARIO_REQUEST';
export const CREATE_USUARIO_SUCCESS = 'CREATE_USUARIO_SUCCESS';
export const CREATE_USUARIO_FAILURE = 'CREATE_USUARIO_FAILURE';

export const FETCH_USUARIOS_REQUEST = 'FETCH_USUARIOS_REQUEST';
export const FETCH_USUARIOS_SUCCESS = 'FETCH_USUARIOS_SUCCESS';
export const FETCH_USUARIOS_FAILURE = 'FETCH_USUARIOS_FAILURE';

export const FETCH_USUARIO_REQUEST = 'FETCH_USUARIO_REQUEST';
export const FETCH_USUARIO_SUCCESS = 'FETCH_USUARIO_SUCCESS';
export const FETCH_USUARIO_FAILURE = 'FETCH_USUARIO_FAILURE';

export const UPDATE_USUARIO_REQUEST = 'UPDATE_USUARIO_REQUEST';
export const UPDATE_USUARIO_SUCCESS = 'UPDATE_USUARIO_SUCCESS';
export const UPDATE_USUARIO_FAILURE = 'UPDATE_USUARIO_FAILURE';

export const DELETE_USUARIO_REQUEST = 'DELETE_USUARIO_REQUEST';
export const DELETE_USUARIO_SUCCESS = 'DELETE_USUARIO_SUCCESS';
export const DELETE_USUARIO_FAILURE = 'DELETE_USUARIO_FAILURE';

export const SET_USUARIOS_PAGE = 'SET_USUARIOS_PAGE';
export const SET_USUARIOS_LIMIT = 'SET_USUARIOS_LIMIT';

export interface CreateUsuarioRequestAction extends Action<typeof CREATE_USUARIO_REQUEST> {
  type: typeof CREATE_USUARIO_REQUEST;
}

export interface CreateUsuarioSuccessAction extends Action<typeof CREATE_USUARIO_SUCCESS> {
  type: typeof CREATE_USUARIO_SUCCESS;
  payload: any;
}

export interface CreateUsuarioFailureAction extends Action<typeof CREATE_USUARIO_FAILURE> {
  type: typeof CREATE_USUARIO_FAILURE;
  payload: string;
}

export interface FetchUsuariosRequestAction extends Action<typeof FETCH_USUARIOS_REQUEST> {
  type: typeof FETCH_USUARIOS_REQUEST;
}

export interface FetchUsuariosSuccessAction extends Action<typeof FETCH_USUARIOS_SUCCESS> {
  type: typeof FETCH_USUARIOS_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchUsuariosFailureAction extends Action<typeof FETCH_USUARIOS_FAILURE> {
  type: typeof FETCH_USUARIOS_FAILURE;
  payload: string;
}

export interface FetchUsuarioRequestAction extends Action<typeof FETCH_USUARIO_REQUEST> {
  type: typeof FETCH_USUARIO_REQUEST;
}

export interface FetchUsuarioSuccessAction extends Action<typeof FETCH_USUARIO_SUCCESS> {
  type: typeof FETCH_USUARIO_SUCCESS;
  payload: any;
}

export interface FetchUsuarioFailureAction extends Action<typeof FETCH_USUARIO_FAILURE> {
  type: typeof FETCH_USUARIO_FAILURE;
  payload: string;
}

export interface UpdateUsuarioRequestAction extends Action<typeof UPDATE_USUARIO_REQUEST> {
  type: typeof UPDATE_USUARIO_REQUEST;
}

export interface UpdateUsuarioSuccessAction extends Action<typeof UPDATE_USUARIO_SUCCESS> {
  type: typeof UPDATE_USUARIO_SUCCESS;
  payload: any;
}

export interface UpdateUsuarioFailureAction extends Action<typeof UPDATE_USUARIO_FAILURE> {
  type: typeof UPDATE_USUARIO_FAILURE;
  payload: string;
}

export interface DeleteUsuarioRequestAction extends Action<typeof DELETE_USUARIO_REQUEST> {
  type: typeof DELETE_USUARIO_REQUEST;
}

export interface DeleteUsuarioSuccessAction extends Action<typeof DELETE_USUARIO_SUCCESS> {
  type: typeof DELETE_USUARIO_SUCCESS;
  payload: string; 
}

export interface DeleteUsuarioFailureAction extends Action<typeof DELETE_USUARIO_FAILURE> {
  type: typeof DELETE_USUARIO_FAILURE;
  payload: string;
}

export interface SetUsuariosPageAction extends Action<typeof SET_USUARIOS_PAGE> {
  type: typeof SET_USUARIOS_PAGE;
  payload: number;
}

export interface SetUsuariosLimitAction extends Action<typeof SET_USUARIOS_LIMIT> {
  type: typeof SET_USUARIOS_LIMIT;
  payload: number;
}

export type UsuariosActionTypes =
  | CreateUsuarioRequestAction
  | CreateUsuarioSuccessAction
  | CreateUsuarioFailureAction
  | FetchUsuariosRequestAction
  | FetchUsuariosSuccessAction
  | FetchUsuariosFailureAction
  | FetchUsuarioRequestAction
  | FetchUsuarioSuccessAction
  | FetchUsuarioFailureAction
  | UpdateUsuarioRequestAction
  | UpdateUsuarioSuccessAction
  | UpdateUsuarioFailureAction
  | DeleteUsuarioRequestAction
  | DeleteUsuarioSuccessAction
  | DeleteUsuarioFailureAction
  | SetUsuariosPageAction
  | SetUsuariosLimitAction;